export default "__VITE_ASSET__DRai8tCy__"